import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';

const clearVolumesCacheForRequest = (request: Promise<any>) => {
  cacheService.removeAllInPath(`/author/curriculum/volumes`);
  return request;
};

export type VolumeCommandValues = {
  name: string;
  startDate: Date;
  endDate: Date;
  image: string;
  number?: number;
  periodTitle?: string;
  availabilityEndDate?: Date;
  description?: string;
  posterUrl?: string;
};

type VolumeCommand = VolumeCommandValues & {
  id: string;
  curriculumId: string;
  initiatingUserId?: string;
};

const generateVolumeCommand = (
  curriculumId: string,
  volumeId: string,
  volumeValues: VolumeCommandValues,
  initiatingUserId?: string
): VolumeCommand => {
  const { number, periodTitle, availabilityEndDate, ...remainingValues } = volumeValues;

  const cmd: VolumeCommand = {
    id: volumeId,
    curriculumId,
    ...remainingValues,
    initiatingUserId,
  };

  if (number) cmd['number'] = number;
  if (periodTitle) cmd['periodTitle'] = periodTitle;
  if (availabilityEndDate) cmd['availabilityEndDate'] = availabilityEndDate;

  return cmd;
};

export const updateVolume = (
  curriculumId: string,
  volumeId: string,
  volumeValues: VolumeCommandValues,
  initiatingUserId?: string
) => {
  const cmd = generateVolumeCommand(curriculumId, volumeId, volumeValues, initiatingUserId);
  return clearVolumesCacheForRequest(
    submitCommand(cmd.id, cmd, 'CvSetVolumeProperties', 'CvVolumePropertiesSet', 'CvCommandFailed')
  );
};

export const createVolume = (curriculumId: string, volumeValues: VolumeCommandValues, initiatingUserId?: string) => {
  const cmd = generateVolumeCommand(curriculumId, uuid.generate(), volumeValues, initiatingUserId);
  return clearVolumesCacheForRequest(
    submitCommand(cmd.id, cmd, 'CvCreateVolume', 'CvVolumeCreated', 'CvCommandFailed')
  );
};
